const zh = {
    home: {
        about: '我们利用先进的单细胞基因组学以及复杂的计算技术，包括机器学习和人工智能，来深入探究人类性腺发育在健康和疾病方面的机制。',
        contentList: [
            { id: '1', title: '利用基因组学和分子生物学技术研究人类精原干细胞', img: "https://cdn.panda.simuhunluo.top/official/aboutus/image9.png", content: '本研究发现了一类人类特有的精原干细胞类型，提出人类精原干细胞双向可逆的发育模型，为精原干细胞的体外培养及分化提供了候选的靶标分子。' },
            { id: '2', title: '男性生殖细胞和睾丸微环境生理状态的关键事件', img: "https://cdn.panda.simuhunluo.top/official/aboutus/image10.png", content: '本研究填补了人类睾丸发育谱系的空白，提出睾丸内生殖细胞和体细胞从胚胎期至青春期的发育模型。阐明了精原干细胞的完整建立过程，优化青少年肿瘤生育力保存技术。' },
            { id: '3', title: '揭示男性不育和生殖肿瘤的病理机制', img: "https://cdn.panda.simuhunluo.top/official/aboutus/image11.png", content: '本研究利用单细胞转录组测序技术对隐睾症这类男性不育疾病进行了系统的分析，揭示了隐睾患者的精子发生障碍主要源于精原受损，睾丸内生精微环境的功能异常，特别是肥大细胞增多和激活脱颗粒等。这些见解具有重要的转化参考价值，丰富了我们对男性不育病理机制的理解，并为未来临床的精确诊断和针对性治疗策略提供了依据。' },
            { id: '4', title: '开发基于人工智能的计算生物学工具来鉴定男性不育的诊疗靶点', img: "https://cdn.panda.simuhunluo.top/official/aboutus/image12.png", content: '本研究基于全面的多中心大样本量临床数据，引入机器学习模型来预测非梗阻性无精子症(NOA)男性在接受显微睾丸精子提取（micro-TESE）的预后。开发了一个名为SpermFinder的在线工具（https://huggingface.co/spaces/SpermFinder/TESE），预测取精成功率(SRR)，为术前评估和患者知情临床决策提供见解。' },
        ]
    },
    people: {
        guoName: '郭靖涛 研究员',
        guoTitle: '课题组长',
        guoInformation: '郭靖涛，中国科学院动物研究所研究员，博士生导师。郭靖涛研究员于2013年本科毕业于北京大学，后赴美国犹他大学攻读博士，毕业后在犹他大学医学院继续深造，进行博士后研究。2020年7月受聘于犹他大学医学院，任准聘助理教授，组建独立课题组，并获多个NIH R01基金资助。2021年12月加入中国科学院动物研究所干细胞与生殖生物学国家重点实验室，任研究组组长。2022年入选国家海外高层次人才计划；获中国科学院战略先导项目、国家重点研发计划、国家自然科学基金面上项目等多个国家级项目资助。以第一作者或通讯作者（含共同）在Cell, Cell Stem Cell, Nature Cell Biology, Nature Communications, Cell Developmental Cell, Cell Research等期刊上发表研究成果,并受邀在中国、美国、德国、瑞典等多个研究所和高校分享研究成果。长期担任Cell Stem Cell, Nature Communications, Cell Reports Medicine等期刊独立审稿人。 ',
        msgList: [
            { post: '副研究员', name: '王晓琰', img: "https://cdn.panda.simuhunluo.top/official/ui/staff2.png", email: '' },
            { post: '管理员', name: '朱倩文', img: "https://cdn.panda.simuhunluo.top/official/people/zhuqianwen.jpg", email: 'zhuqw(at)ioz.ac.cn' },
        ],
        staff:'职工',
        postdoc:'博士后',
        postdocList:[
            {
                imgList: [
                    { id: '2', name: '岳静伟', img: "https://cdn.panda.simuhunluo.top/official/ui/staff3.png" },
                    { id: '3', name: '崔利娜', img: "https://cdn.panda.simuhunluo.top/official/people/image18_3.jpg" },
                    { id: '5', name: '卢晓健', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%201843.png" },
                    { id: '4', name: '张文秀', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%201842.png" },
                ]
            },
        ],
        student:'学生',
        studentList: [
            { post: '< 博士研究生 >',
                imgList: [
                    { id: '6', name: '蔡卉', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%20139.png" },
                    { id: '7', name: '郭一菲', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%20840.png" },
                    { id: '8', name: '李冉', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%2041.png" },
                    { id: '9', name: '庄子研', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%20189.png" },
                    { id: '11', name: '蒋巧玲', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%2012.png"},
                    { id: '12', name: '李杨', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%2010.png" },
                    { id: '13', name: '关施旗', img: "https://cdn.panda.simuhunluo.top/official/people/关施旗.jpg" },
                    { id: '2', name: '白怡凡', img: "https://cdn.panda.simuhunluo.top/official/people/白怡凡.jpg" },
                    { id: '5', name: '党晨欣', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%20143.png" },
                ]
            },
            { post: '< 硕士研究生 >',
                imgList: [
                    { id: '4', name: '刘昱雯', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%20182.png" },
                    { id: '6', name: '卢芷瑶', img: "https://cdn.panda.simuhunluo.top/official/people/卢芷瑶.jpg" },
                    { id: '7', name: '王泽健', img: "https://cdn.panda.simuhunluo.top/official/people/王泽健.jpg" },
                    { id: '3', name: '范学嘉', img: "https://cdn.panda.simuhunluo.top/official/people/2026范学嘉.jpg" },
                    { id: '8', name: '贺海洋', img: "https://cdn.panda.simuhunluo.top/official/people/贺海洋.jpg" },
                    { id: '9', name: '杨佳', img: "https://cdn.panda.simuhunluo.top/official/people/杨佳.jpg" },
                ]
            },
            { post: '< 联培生 >',
                imgList: [
                    { id: '2', name: '任鹏程', img: "https://cdn.panda.simuhunluo.top/official/ui/Ellipse%2013.png", university: "南京医科大学" },
                ]
            },
            { post: '< 实习生 >',
                imgList: [
                    { id: '4', name: '汤延淋', img: "https://cdn.panda.simuhunluo.top/official/people/汤延淋.jpg" },
                ]
            },
        ],
        alumni:'毕业生',
        alumniList:[
            { id: '1', name: '苗鹤凡'},
            { id: '2', name: '章百灵'},
        ]
    },
}
export default zh;
